import React from "react";
import "./hayat/content/css/admin/style.css";
import "./hayat/content/css/admin/login.css";
import "@reach/dialog/styles.css";
import "@reach/tabs/styles.css";
import { useAuth } from "context/auth-context";
import { FullPageSpinner } from "component/lib";

const AuthenticatedApp = React.lazy(() =>
  import(/* webpackPrefetch: true */ "./AuthenticatedApp")
);
const UnauthenticatedApp = React.lazy(() => import("./UnauthenticatedApp"));

function App() {
  const { user } = useAuth();
  return (
    <React.Suspense fallback={<FullPageSpinner />}>
      {user ? <AuthenticatedApp /> : <UnauthenticatedApp />}
    </React.Suspense>
  );
}

export default App;
